import { useProxyModelValue as A } from "@onereach/ui-components-common/hooks";
import { O as N } from "./OrButton-C_hXddAf.mjs";
import { O as x } from "./OrCheckbox-CARHvboD.mjs";
import { O as R } from "./OrIcon-k8cyvh-D.mjs";
import { useToggle as z } from "@vueuse/core";
import { defineComponent as D, toRefs as E, computed as t, watch as U, resolveComponent as b, openBlock as d, createElementBlock as c, normalizeClass as u, Fragment as T, createElementVNode as j, createBlock as C, withCtx as f, createVNode as $, createCommentVNode as I, renderSlot as O, createTextVNode as V, toDisplayString as h, renderList as q } from "vue";
import { flattenDeep as F } from "@onereach/ui-components-common/utils";
import { _ as G } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const H = [
  // Layout
  "flex",
  "flex-col",
  // Spacing
  "md:gap-sm"
], J = [
  // Layout
  "flex",
  "flex-row",
  "gap-xs"
], w = (e) => e == null ? void 0 : e.map((o) => {
  if (!o.disabled)
    return o.children ? w(o.children) : o.value;
});
function K(e) {
  return F(w(e)).filter(Boolean);
}
const Q = D({
  name: "OrCheckboxTree",
  components: {
    OrIcon: R,
    OrCheckbox: x,
    OrButton: N
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    item: {
      type: Object,
      required: !0
    },
    collapsible: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    expanded: {
      type: Boolean,
      default: !0
    }
  },
  emits: [
    "update:modelValue"
  ],
  setup(e, o) {
    const { modelValue: g, item: B, expanded: v } = E(e), y = t(() => B.value.children || []), m = t(() => y.value.length > 0), n = t(() => m.value ? K(y.value) : []), a = A(g, o.emit), p = t(() => {
      var r;
      return (r = a.value) == null ? void 0 : r.some((k) => {
        var i;
        return (i = n.value) == null ? void 0 : i.includes(k);
      });
    }), l = t(() => {
      var r;
      return n.value.length > 0 && ((r = n.value) == null ? void 0 : r.every((k) => {
        var i;
        return (i = a.value) == null ? void 0 : i.includes(k);
      }));
    }), s = t(() => p.value && !l.value), [M, S] = z(v.value);
    U(v, (r) => {
      r !== void 0 && S(r);
    });
    const L = t(() => [
      "or-checkbox-tree-v3",
      ...H
    ]), P = t(() => [
      ...J
    ]);
    return {
      rootStyles: L,
      parentStyles: P,
      hasChildren: m,
      proxyModelValue: a,
      isOpen: M,
      setIsOpen: S,
      isIntermediate: s,
      isAllChildrenSelected: l,
      isAnyChildrenSelected: p,
      childrenValues: n,
      handleParentClick: () => {
        l.value ? a.value = a.value.filter((r) => !n.value.includes(r)) : a.value = [
          .../* @__PURE__ */ new Set([
            ...a.value,
            ...n.value
          ])
        ];
      }
    };
  }
});
function W(e, o, g, B, v, y) {
  const m = b("OrIcon"), n = b("OrButton"), a = b("OrCheckbox"), p = b("OrCheckboxTree", !0);
  return d(), c("div", {
    ref: "root",
    class: u(e.rootStyles)
  }, [
    e.hasChildren ? (d(), c(T, { key: 0 }, [
      j("div", {
        class: u(e.parentStyles)
      }, [
        e.collapsible ? (d(), C(n, {
          key: 0,
          variant: "link",
          disabled: e.disabled,
          onClick: o[0] || (o[0] = (l) => e.setIsOpen(!e.isOpen))
        }, {
          default: f(() => [
            $(m, {
              class: u([e.isOpen ? "rotate-[180deg]" : "rotate-0"]),
              icon: "arrow_drop_down",
              size: "l"
            }, null, 8, ["class"])
          ]),
          _: 1
        }, 8, ["disabled"])) : I("", !0),
        $(a, {
          "model-value": e.isAllChildrenSelected,
          value: !0,
          indeterminate: e.isIntermediate,
          disabled: e.disabled,
          readonly: e.readonly,
          onClick: e.handleParentClick
        }, {
          default: f(() => [
            O(e.$slots, "checkboxLabel", { item: e.item }, () => [
              V(h(e.item.label), 1)
            ])
          ]),
          _: 3
        }, 8, ["model-value", "indeterminate", "disabled", "readonly", "onClick"])
      ], 2),
      e.hasChildren && e.isOpen ? (d(), c("div", {
        key: 0,
        class: u([e.collapsible ? "ml-2xl" : "ml-lg"])
      }, [
        (d(!0), c(T, null, q(e.item.children, (l) => (d(), C(p, {
          key: l.value || l.label,
          modelValue: e.proxyModelValue,
          "onUpdate:modelValue": o[1] || (o[1] = (s) => e.proxyModelValue = s),
          class: u(["mt-xs"]),
          item: l,
          collapsible: l.collapsible,
          expanded: l.expanded,
          disabled: e.disabled || l.disabled,
          readonly: e.readonly || l.readonly
        }, {
          checkboxLabel: f(({ item: s }) => [
            O(e.$slots, "checkboxLabel", { item: s }, () => [
              V(h(s.label), 1)
            ])
          ]),
          _: 2
        }, 1032, ["modelValue", "item", "collapsible", "expanded", "disabled", "readonly"]))), 128))
      ], 2)) : I("", !0)
    ], 64)) : (d(), C(a, {
      key: 1,
      modelValue: e.proxyModelValue,
      "onUpdate:modelValue": o[2] || (o[2] = (l) => e.proxyModelValue = l),
      value: e.item.value,
      disabled: e.disabled || e.item.disabled,
      readonly: e.readonly || e.item.readonly
    }, {
      default: f(() => [
        O(e.$slots, "checkboxLabel", { item: e.item }, () => [
          V(h(e.item.label), 1)
        ])
      ]),
      _: 3
    }, 8, ["modelValue", "value", "disabled", "readonly"]))
  ], 2);
}
const ne = /* @__PURE__ */ G(Q, [["render", W]]);
export {
  ne as O
};
//# sourceMappingURL=OrCheckboxTree-D6KuOyBg.mjs.map
